module.exports = __webpack_public_path__ + "img/Monte_Kope_78.a2a26a84.jpg";